import dayjs from 'dayjs';

const QUESTIONNAIRE_ACTIONS = [
  { text: 'verify questionnaire', route: '/administrator/evaluation_template' },
  { text: 'enable the questionnaire', route: '/administrator/settings/evaluation' },
];

// Department issues shown in the admin banner count and the issues modal.
// interviewDates is sorted ascending. `now` is injectable for tests.
export const getQuestionnaireIssues = (season, interviewDates, now = dayjs()) => {
  if (!season || !interviewDates || interviewDates.length === 0) {
    return [];
  }

  const issues = [];
  const firstInterviewDate = interviewDates[0];
  const firstInterviewDateTime = dayjs(`${firstInterviewDate.DateOfInterview} ${firstInterviewDate.StartTime}`);
  const daysUntilFirstInterview = firstInterviewDateTime.diff(now, 'day');

  // Get the LATEST interview date (last element since sorted ascending)
  const lastInterviewDate = interviewDates[interviewDates.length - 1];
  const lastInterviewDateTime = dayjs(`${lastInterviewDate.DateOfInterview} ${lastInterviewDate.StartTime}`);

  // If the latest interview date is in the past, don't show any warnings
  if (lastInterviewDateTime.isBefore(now)) {
    return [];
  }

  // Check if first interview date is in the past (for prescreen warnings)
  const firstInterviewIsPast = firstInterviewDateTime.isBefore(now);

  // Check if any evaluators have assigned candidates
  const hasAssignedCandidates = interviewDates.some((date) => date.CountOfCandidates > 0);

  // "Do not Prescreen Candidates" saves AllowPrescreen = 0. Prescreen-specific
  // issues only apply when the selected season prescreens candidates.
  const prescreenEnabled = Boolean(season.AllowPrescreen);

  // Condition 1: Evaluators have assigned candidates AND more than 7 days before interview AND prescreen questionnaire disabled
  // ONLY show if first interview is NOT in the past
  if (
    prescreenEnabled &&
    hasAssignedCandidates &&
    daysUntilFirstInterview > 7 &&
    !season.EnablePrescreenQuestionnaire &&
    !firstInterviewIsPast
  ) {
    issues.push({
      title: 'Prescreen Questionnaire Disabled',
      description:
        'The prescreen questionnaire is currently disabled. Please verify your prescreen questionnaire is ready to be used and enable the questionnaire.',
      actions: QUESTIONNAIRE_ACTIONS,
    });
  }

  // Condition 2: Prescreen is set to default AND questionnaire not enabled
  // ONLY show if first interview is NOT in the past
  if (
    prescreenEnabled &&
    season.EnablePrescreenMode === true &&
    !season.EnablePrescreenQuestionnaire &&
    !firstInterviewIsPast
  ) {
    issues.push({
      title: 'Prescreen Questionnaire Disabled',
      description:
        'The prescreen questionnaire is currently disabled. Please verify your prescreen questionnaire is ready to be used and enable the questionnaire for evaluators.',
      actions: QUESTIONNAIRE_ACTIONS,
    });
  }

  // Condition 3: Less than 8 days to first interview AND evaluation questionnaire disabled
  if (daysUntilFirstInterview < 8 && !season.EnableEvaluationQuestionnaire) {
    issues.push({
      title: 'Evaluation Questionnaire Disabled',
      description:
        'The evaluation questionnaire is currently disabled. Please verify your evaluation questionnaire is ready to be used and enable the questionnaire for evaluators.',
      actions: QUESTIONNAIRE_ACTIONS,
    });
  }

  // Condition 4: Less than 8 days to first interview AND default mode is NOT evaluation
  if (prescreenEnabled && daysUntilFirstInterview < 8 && season.EnablePrescreenMode === true) {
    issues.push({
      title: 'Interviews Coming Up Soon',
      description:
        "Interviews are coming up soon, if you're done prescreening, we recommend you set the evaluation questionnaire to default.",
      actions: [{ text: 'set the evaluation questionnaire to default', route: '/administrator/settings/evaluation' }],
    });
  }

  return issues;
};
